import { gql } from '@apollo/client'

export const SHOP_CUSTOM_FEE_FRAGMENT = gql`
  fragment ShopCustomFee on ShopCustomFee {
    applied {
      amount
      format
    }
    appliedTax {
      amount
      format
    }
    tax {
      id
      name
    }
    description
    id
    name
  }
`
